import { render, staticRenderFns } from "./AppSimpleTextField.vue?vue&type=template&id=8040a49a&scoped=true&"
import script from "./AppSimpleTextField.vue?vue&type=script&lang=ts&"
export * from "./AppSimpleTextField.vue?vue&type=script&lang=ts&"
import style0 from "./AppSimpleTextField.vue?vue&type=style&index=0&id=8040a49a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8040a49a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VImg,VTextField})
